import createStyles from "@material-ui/core/styles/createStyles";
import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles((theme) => {
  return createStyles({
    root: {
      background: theme.palette.grey["A1000"],
      borderColor: theme.palette.grey["700"],
      height: "100%"
    },
    tabs: {
      color: "white",
      fontWeight: 500,
      background: theme.palette.grey["800"],
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.grey["700"]}`
    }
  });
});
